// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.point span[data-v-287ce750]{\n  font-size: 17px;\n  font-weight: bold;\n  color:red;\n}\n\n", ""]);
// Exports
module.exports = exports;
